import { uniq } from 'lodash';
import { useSelector } from 'react-redux';
import { roundedDurationSelector } from '../../ecg/selectors/ecg.selectors';
import { Navigator } from '../../navigation/components/Navigator';
import { useStrip } from '../hooks/useStrip';
import { visibleStripsSelector } from '../selectors/strip.selectors';
import { DefaultLeads } from './DefaultLeads';

export const MinuteGraph: React.FC = () => {
  const { stripId, onset, offset } = useStrip();
  const ecgDuration = useSelector(roundedDurationSelector);
  const visibleStrips = useSelector(visibleStripsSelector);
  const durations = uniq(
    visibleStrips
      .filter(
        ({ id, duration }) =>
          id !== stripId && duration < ecgDuration + onset + offset,
      )
      .map(({ duration }) => duration),
  ).sort((a, b) => a - b);

  return (
    <Navigator durations={durations}>
      <DefaultLeads />
    </Navigator>
  );
};
